import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AppDialogComponent from "components/mui/AppDialogComponent";
import AppTextFieldComponent from "components/mui/AppTextFieldComponent";
import AppButtonComponent from "components/mui/AppButtonComponent";
import { FormControl, Select, MenuItem } from "@mui/material";
// Component scope - Constants
const SUCCESS_ICON_SX = {
  fontSize: 60,
  color: "#28C76F",
  mb: 2,
};

const SUCCESS_CONTAINER_SX = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  py: 5,
  textAlign: "center",
};

/**
 * Service Request Modal Component
 * Pure UI component for displaying service request form or success message
 * @component
 */
const ServiceRequestModal = ({
  open = false,
  onClose,
  onSubmit,
  loading = false,
  showSuccess = false,
  query = "",
  reason = "",
  reasons = [],
  onReasonChange,
  onQueryChange,
  reasonError = "",
  queryError = "",
  disabled = false,
  minLength = 0,
  maxLength = 1000,
  modalTitle = "Need Help? Reach Out to us",
}) => {
  const theme = useTheme();

  // Counter and max limit use non-space characters only; empty check uses trimmed text
  const trimmedQuery = query?.trim?.() ?? "";
  const charCount = query?.replace?.(/\s/g, "")?.length ?? 0;
  const isMinLengthMet = (charCount ?? 0) >= (minLength ?? 0);
  const isMaxLengthExceeded = (charCount ?? 0) > (maxLength ?? 0);
  const isAtMaxLength = (charCount ?? 0) >= (maxLength ?? 0);
  const isReasonSelected = (reason?.trim?.() ?? "") !== "";
  const isQueryEmpty = (trimmedQuery?.length ?? 0) === 0;
  const hasReasonError = (reasonError?.trim?.() ?? "") !== "";
  const hasQueryError = (queryError?.trim?.() ?? "") !== "" || (isAtMaxLength ?? false);
  const queryErrorMessage =
    (queryError?.trim?.() ?? "") !== ""
      ? (queryError ?? "")
      : (isAtMaxLength ?? false)
        ? "Maximum limit reached."
        : "";

  // Validation logic
  const isFormValid =
    (isReasonSelected ?? false) &&
    !(isQueryEmpty ?? true) &&
    (isMinLengthMet ?? false) &&
    !(isMaxLengthExceeded ?? false);
  // Return/rendering
  return (
    <AppDialogComponent
      open={open ?? false}
      onClose={onClose}
      title={(showSuccess ?? false) ? "" : (modalTitle ?? "Need Help? Reach Out to us")}
      //   maxWidth={false}
      //   fullWidth={true}
      showCloseButton={true}
      sx={{
        "& .MuiDialog-paper": {
          bgcolor: "#1A1F33",
          color: "#fff",
          borderRadius: "12px",
          padding: "24px",
          width: "100%",
          maxWidth: {
            xs: "90vw",
            sm: "335px",
            md: "400px",
          },

          //   maxWidth: '400px',
          minHeight: "256px",
          margin: {
            xs: "16px",
            sm: "auto",
          },
        },
        "& .MuiDialogTitle-root": {
          padding: 0,
          paddingBottom: "18px",
        },
        "& .MuiDialogContent-root": {
          padding: 0,
          gap: "24px",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {(showSuccess ?? false) ? (
        <Box sx={SUCCESS_CONTAINER_SX}>
          <CheckCircleOutlineIcon sx={SUCCESS_ICON_SX} />
          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: "#F0F0F0", fontWeight: 600, mb: "5" }}
          >
            Query Submitted successfully.
          </Typography>
          <Typography variant="body2" sx={{ color: "#CCCCCC" }}>
            Your RM will get back to you soon to resolve your query.
          </Typography>
        </Box>
      ) : (
        <Box
          component="form"
          onSubmit={onSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          {/* Dropdown for reasons */}
          {/* <AppTextFieldComponent
            label="Select Reason"
            value={reason}
            onChange={onReasonChange}
            fullWidth
            disabled={loading}
            InputLabelProps={{ shrink: true }}
            sx={{
              '& .MuiOutlinedInput-root': {
                color: '#F0F0F0',
                '& fieldset': {
                  borderColor: '#3A3A3A'
                },
                '&:hover fieldset': {
                  borderColor: '#D8D8D8',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#46A8DC'
                }
              },
              '& .MuiInputLabel-root': {
                color: '#CCCCCC',
                position: 'absolute',
                left: '10px',
                // padding: '0 40px',
                zIndex: 1000,
                transform: 'none',
                fontSize: '13px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                '&.MuiInputLabel-shrink': {
                  transform: 'none',
                  top: '-4px',
                }
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#46A8DC'
              },
              '& .MuiOutlinedInput-notchedOutline': {
                top: 0,
              },
              '& .MuiInputBase-input': {
                paddingTop: '20px'
              }
            }}
          /> */}
          {/* <FormControl fullWidth sx={{ position: 'relative' }}>
            <Typography
              sx={{
                position: 'absolute',
                top: '-9px',
                left: '10px',
                fontSize: '13px',
                color: reason ? '#46A8DC' : '#CCCCCC',
                bgcolor: '#1A1F33',
                px: '4px',
                zIndex: 1,
                pointerEvents: 'none',
                lineHeight: 1,
              }}
            >
              Select Reason
            </Typography>

            <Select
              value={reason}
              onChange={onReasonChange}
              disabled={loading}
              displayEmpty
              renderValue={(selected) => (
                <Typography sx={{ color: selected ? '#F0F0F0' : '#888888', fontSize: '14px' }}>
                  {selected || ''}
                </Typography>
              )}
              MenuProps={{
                disablePortal: false,
                disableScrollLock: true,
                PaperProps: {
                  sx: {
                    bgcolor: '#1A1F33',
                    color: '#F0F0F0',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    mt: '4px',
                    border: '1px solid #3A3A3A',
                    borderRadius: '8px',
                    zIndex: 99999,
                    '& .MuiMenuItem-root': {
                      color: '#F0F0F0',
                      fontSize: '13px',
                      py: '10px',
                      px: '14px',
                      '&:hover': { bgcolor: '#2A2F45' },
                      '&.Mui-selected': {
                        bgcolor: '#2A3A4A',
                        '&:hover': { bgcolor: '#2A3A4A' }
                      }
                    },
                    '& .MuiList-root': { padding: 0 }
                  }
                },
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
              }}
              sx={{
                bgcolor: '#1A1F33',
                borderRadius: '8px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#3A3A3A',
                  '& legend': { width: 0 }
                },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#D8D8D8' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#46A8DC' },
                '& .MuiSvgIcon-root': { color: '#F0F0F0' }
              }}
            >
              {reasons.map((item) => (
                <MenuItem key={item} value={item}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <AppTextFieldComponent
            label="Select Reason"
            value={reason ?? ""}
            // placeholder="Select Reason"
            onChange={onReasonChange}
            fullWidth
            select
            required
            disabled={loading ?? false}
            error={hasReasonError ?? false}
            InputLabelProps={{ shrink: true }}
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#F0F0F0",
                "& fieldset": {
                  borderColor: (hasReasonError ?? false) ? "#FF4D4F" : "#3A3A3A",
                },
                "&:hover fieldset": {
                  borderColor: (hasReasonError ?? false) ? "#FF4D4F" : "#D8D8D8",
                },
                "&.Mui-focused fieldset": {
                  borderColor: (hasReasonError ?? false) ? "#FF4D4F" : "#46A8DC",
                },
              },
              "& .MuiInputLabel-root": {
                color: "#CCCCCC",
                position: "absolute",
                left: "10px",
                zIndex: 1000,
                transform: "none",
                fontSize: "13px",
                "&.MuiInputLabel-shrink": { transform: "none", top: "-4px" },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: (hasReasonError ?? false) ? "#FF4D4F" : "#46A8DC",
              },
              "& .MuiInputLabel-asterisk": { color: "#EF4444" },
              "& .MuiOutlinedInput-notchedOutline": { top: 0 },
              "& .MuiSvgIcon-root": { color: "#F0F0F0" },
            }}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected) => (
                <Typography
                  sx={{
                    color: (selected ?? "") ? "#F0F0F0" : "#888888",
                    fontSize: "14px",
                  }}
                >
                  {selected ?? "Choose a reason"}
                </Typography>
              ),
              MenuProps: {
                disablePortal: false,
                disableScrollLock: true,
                PaperProps: {
                  sx: {
                    bgcolor: "#1A1F33",
                    color: "#F0F0F0",
                    maxHeight: "200px",
                    overflowY: "auto",
                    mt: "4px",
                    border: "1px solid #3A3A3A",
                    borderRadius: "8px",
                    zIndex: 99999,
                    "& .MuiMenuItem-root": {
                      color: "#F0F0F0",
                      fontSize: "13px",
                      py: "10px",
                      px: "14px",
                      "&:hover": { bgcolor: "#2A2F45" },
                      "&.Mui-selected": {
                        bgcolor: "#2A3A4A",
                        "&:hover": { bgcolor: "#2A3A4A" },
                      },
                    },
                    "& .MuiList-root": { padding: 0 },
                  },
                },
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
              },
            }}
          >
            {reasons?.map?.((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            )) ?? null}
          </AppTextFieldComponent>
          {(hasReasonError ?? false) ? (
            <Typography
              variant="caption"
              sx={{ color: "#FF4D4F", fontSize: "12px", mt: -2, px: 1 }}
            >
              {reasonError ?? "Please select a reason."}
            </Typography>
          ) : null}

          <AppTextFieldComponent
            label="Enter your query"
            placeholder="Please Enter your query"
            value={query ?? ""}
            onChange={onQueryChange}
            fullWidth
            multiline
            rows={4}
            required
            disabled={loading ?? false}
            InputLabelProps={{ shrink: true }}
            error={hasQueryError ?? false}
            sx={{
              "& .MuiOutlinedInput-root": {
                color: "#F0F0F0",
                "& fieldset": {
                  borderColor: (hasQueryError ?? false) ? "#FF4D4F" : "#3A3A3A",
                },
                "&:hover fieldset": {
                  borderColor: (hasQueryError ?? false) ? "#FF4D4F" : "#D8D8D8",
                },
                "&.Mui-focused fieldset": {
                  borderColor: (hasQueryError ?? false) ? "#FF4D4F" : "#46A8DC",
                },
              },
              "& .MuiInputLabel-root": {
                color: "#CCCCCC",
                position: "absolute",
                left: "10px",
                // padding: '0 40px',
                zIndex: 1000,
                transform: "none",
                fontSize: "13px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                "&.MuiInputLabel-shrink": {
                  transform: "none",
                  top: "-4px",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: (hasQueryError ?? false) ? "#FF4D4F" : "#46A8DC",
              },
              "& .MuiInputLabel-asterisk": { color: "#EF4444" },
              "& .MuiOutlinedInput-notchedOutline": {
                top: 0,
              },
              "& .MuiInputBase-input": {
                paddingTop: "20px",
              },
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: -2,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "#FF4D4F",
                fontSize: "12px",
                visibility: (hasQueryError ?? false) ? "visible" : "hidden",
              }}
            >
              {queryErrorMessage ?? "Maximum limit reached."}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: (hasQueryError ?? false) ? "#FF4D4F" : "#CCCCCC",
                fontSize: "12px",
              }}
            >
              {charCount ?? 0}/{maxLength ?? 0}
            </Typography>
          </Box>

          <AppButtonComponent
            type="submit"
            variant="contained"
            fullWidth
            loading={loading ?? false}
            disabled={(disabled ?? false) || (loading ?? false) || !(isFormValid ?? false)}
            sx={{
              bgcolor: theme?.palette?.custom?.button?.primary ?? "#46A8DC",
              color: theme?.palette?.custom?.text?.buttonOnPrimary ?? "#FFFFFF",
              "&:hover": {
                bgcolor: theme?.palette?.primary?.dark ?? "#3B8DB8",
              },
              "&:disabled": {
                bgcolor: theme?.palette?.custom?.button?.disabled ?? "#A6A6A6",
                color: theme?.palette?.custom?.text?.buttonOnDisabled ?? "#F8F8F8",
              },
              "&.Mui-disabled": {
                bgcolor: theme?.palette?.custom?.button?.disabled ?? "#A6A6A6",
                color: theme?.palette?.custom?.text?.buttonOnDisabled ?? "#F8F8F8",
              },
            }}
          >
            Submit
          </AppButtonComponent>
        </Box>
      )}
    </AppDialogComponent>
  );
};

ServiceRequestModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  showSuccess: PropTypes.bool,
  query: PropTypes.string,
  onQueryChange: PropTypes.func.isRequired,
  reason: PropTypes.string,
  reasons: PropTypes.arrayOf(PropTypes.string),
  onReasonChange: PropTypes.func.isRequired,
  reasonError: PropTypes.string,
  queryError: PropTypes.string,
  disabled: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  modalTitle: PropTypes.string,
};

export default ServiceRequestModal;
